class AnonymousUserIdService {
    constructor(Restangular) {

        function createAnonymousId() {
            return Date.now().toString(36) + Math.random().toString(36).substr(2);
        }

        function checkAnonymousIdInLocalStorage(id) {
            return localStorage.getItem(id);
        }

        function setAnonymousIdInLocalStorage(id) {
            localStorage.setItem('sponsoredAdAnonymousId', id);
        }

        this.getAnonymousId = function () {
            const checkAnonymousId = checkAnonymousIdInLocalStorage('sponsoredAdAnonymousId');
            if (checkAnonymousId) {
                return checkAnonymousId;
            } else {
                const id = createAnonymousId();
                const AnonymousId = id.toString();
                setAnonymousIdInLocalStorage(AnonymousId);
                return AnonymousId;
            }

        };

        this.setAnonymousIdInDB = function () {
            return Restangular.one('Checkout/').post('SponsoredAdsSessionId', { "SponsoredAdsSessionId": this.getAnonymousId() });
        }
    }
}

module.exports = AnonymousUserIdService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/anonymoususerid/anonymous-userid-service.js
 **/